import { call, put, takeEvery } from 'redux-saga/effects';
import { mockColleges } from '../../../../utils/mockData';
import * as actions from './_actions';
import * as types from './_actionTypes';
import SMENotificationHelper from '../../../../utils/API/BackendHelper/sme/notifications';
import { yearsToDays } from 'date-fns';
import notifications from '../../../../utils/API/BackendHelper/sme/notifications';

function* fetchNotificationsSaga() {
  try {
  const Notifications=  yield call(SMENotificationHelper.getNotifications);
    yield put(actions.fetchNotificationsSuccess(Notifications.data));
  } catch (error) {
    yield put(actions.fetchNotificationsFailure(error.message));
  }
}


function* fetchCoursesListSaga() {
  try {
     const res = yield call(SMENotificationHelper.getCourses); 
     console.log(res); // Call the API to fetch courses
     yield put(actions.fetchCoursesListSuccess(res.data));
  } catch (error) {
    yield put(actions.fetchCoursesListFailure(error.message));
  }
}

function* fetchCollegesListSaga(action) {
  try {
    console.log('Fetching colleges for course ID:', action.payload);
    const approvedColleges = yield call(SMENotificationHelper.getCollegesByCourse, action.payload);
    yield put(actions.fetchCollegesListSuccess(approvedColleges.data));
  } catch (error) {
    yield put(actions.fetchCollegesListFailure(error.message));
  }
}

function* sendNotificationSaga(action) {
  try {
    const res = yield call(SMENotificationHelper.sendNotification, action.payload);
    yield put(actions.sendNotificationSuccess(res.data));
  } catch (error) {
    yield put(actions.sendNotificationFailure(error.message));
  }
}

function* deleteNotificationSaga(action) {
  try {
    console.log('Deleting notification with ID:', action.payload);
    yield call(SMENotificationHelper.deleteNotification, action.payload);
    yield put(actions.deleteNotificationSuccess(action.payload));
  } catch (error) {
    yield put(actions.deleteNotificationFailure(error.message));
  }
}

function* smeNotificationsSaga() {
  yield takeEvery(types.FETCH_NOTIFICATIONS_REQUEST, fetchNotificationsSaga);
  yield takeEvery(types.FETCH_COLLEGES_LIST_REQUEST, fetchCollegesListSaga);
  yield takeEvery(types.SEND_NOTIFICATION_REQUEST, sendNotificationSaga);
  yield takeEvery(types.DELETE_NOTIFICATION_REQUEST, deleteNotificationSaga);
  yield takeEvery(types.FETCH_COURSES_LIST_REQUEST, fetchCoursesListSaga);
}

export default smeNotificationsSaga;